export default {
  methods: {
    getExpressLink(url) {
      return `
      javascript: function superButtonInit(baseUrl) {
        function superButtonGetContactString(encode, location) {
          if (location.href.match(new RegExp('^https:\\/\\/(.*)?((hh\\.(ru|kz))|(jobs\\.tut\\.by)|(rabota\\.by))\\/resume\\/(.*)?$', 'i'))) {
            /*hh*/
            var name = $(document.body).find('[data-qa=resume-personal-name]:first');
            var email = $(document.body).find('[data-qa=resume-contact-email]:first span');
            var phone = $(document.body).find('[data-qa=resume-contacts-phone]:first').children('a');

            if (phone.text().length >= 17) {
              return '&name=' + (name ? encode(name.text()) : '') +
                '&email=' + (email ? encode(email.text()) : '') +
                '&phone=' + (phone ? encode($.trim(phone.text())) : '');
            } else {
              var btn = $('[data-qa="response-resume_show-phone-number"]:first');
              if (btn && btn.length) {
                btn.click();
              }
              phone = $(document.body).find('[data-qa=resume-contacts-phone]:first span');

              return '&name=' + (name ? encode(name.text()) : '') +
                '&email=' + (email ? encode(email.text()) : '') +
                '&phone=' + (phone ? encode($.trim(phone.text())) : '');
            }
          }
          else if (location.href.match(new RegExp('^https:\\/\\/(.*)?superjob\\.ru\\/resume\\/(.*)?$', 'i'))) {
            var name = $(document.body).find('.ResumeMainHRNew_content .sj_h3:first'),
              email = $(document.body).find('.ResumeMainHRNew_content a[href^=mailto]:first', document.body),
              phone = $(document.body).find('.ResumeMainHRNew_content .sj_block.m_t_2.sj_h3.m_b_0:first', document.body);
            /*superjob*/
            return '&name=' + (name ? encode(name.text()) : '') +
              '&email=' + (email ? encode(email.text()) : '') +
              '&phone=' + (phone && phone.length ? encode(phone.contents().get(0).nodeValue) : '');
          }
          else {
            return '';

          }
        }
        var a = window, b = document, c = encodeURIComponent,
          d = a.open(baseUrl + 'express-invites-popup/?cvurl=' + c(window.location.href) + superButtonGetContactString(c, document.location), 'bkmk_popup', 'left=' + ((a.screenX || a.screenLeft) + 10) + ',top=' + ((a.screenY || a.screenTop) + 10) + ',width=830,height=640,resizable=1,alwaysRaised=1');

        a.setTimeout(function () {
          d.focus()
        }, 300)
      }

      superButtonInit('${url}');
      `;
    }
  }
};
